module.exports = __webpack_public_path__ + "media/images/ohap_calendar_left_arrow-9d734703c796eaa222068af0d9e625c3.png";